// TopShelf Aquarium Heater Size Calculator: volume + temperature gap -> recommended wattage.
document.addEventListener('DOMContentLoaded', function () {
  var volEl = document.getElementById('tsHeaterVolume');
  var unitEl = document.getElementById('tsHeaterUnit');
  var roomEl = document.getElementById('tsHeaterRoom');
  var targetEl = document.getElementById('tsHeaterTarget');
  var result = document.getElementById('tsHeaterResult');

  if (!volEl || !unitEl || !roomEl || !targetEl || !result) {
    return;
  }

  function wattsPerGallon(diff) {
    if (diff <= 5) return 3;
    if (diff <= 10) return 4;
    if (diff <= 15) return 5;
    return 6;
  }

  function roundTo(n, step) {
    return Math.ceil(n / step) * step;
  }

  function compute() {
    var vol = parseFloat(volEl.value);
    var room = parseFloat(roomEl.value);
    var target = parseFloat(targetEl.value);

    if (!vol || vol <= 0) {
      result.innerHTML = '<p class="ts-widget__hint">Enter your tank volume to size a heater.</p>';
      return;
    }

    var gallons = unitEl.value === 'liters' ? vol / 3.78541 : vol;
    var diff = 10; // sensible default rise if temps are blank
    if (!isNaN(room) && !isNaN(target)) {
      diff = Math.max(target - room, 0);
    }

    var wpg = wattsPerGallon(diff);
    var watts = roundTo(gallons * wpg, 25);
    var twoHeater = roundTo(watts / 2, 25);

    var splitNote = watts > 250
      ? ' For a tank this size, two ' + twoHeater + ' W heaters are often safer than one large unit &mdash; if one fails on, the other cannot overheat the tank alone.'
      : '';

    result.innerHTML =
      '<ul class="ts-widget__results">' +
      '<li><span>Recommended heater</span><strong>' + watts + ' W</strong></li>' +
      '<li><span>Rate used</span><strong>' + wpg + ' W/gal</strong></li>' +
      '</ul>' +
      '<p class="ts-widget__note">Based on about ' + wpg + ' watts per gallon for a ' + diff + ' degree Fahrenheit rise. Round to the nearest available heater size.' + splitNote + '</p>';
  }

  [volEl, roomEl, targetEl].forEach(function (el) {
    el.addEventListener('input', compute);
  });
  unitEl.addEventListener('change', compute);
  compute();
});
